export const mergeConfigs = (defaultConfig, configOverrides) => {
    if (!configOverrides || Object.keys(configOverrides).length === 0) {
        return defaultConfig;
    }
    const mergedConfig = Object.entries(defaultConfig).reduce((result, [key, defaultValue]) => {
        var _a;
        if (typeof defaultValue === 'object') {
            result[key] = mergeConfigs(defaultValue, configOverrides === null || configOverrides === void 0 ? void 0 : configOverrides[key]);
        }
        else {
            result[key] = ((_a = configOverrides === null || configOverrides === void 0 ? void 0 : configOverrides[key]) !== null && _a !== void 0 ? _a : defaultValue);
        }
        return result;
    }, {});
    return mergedConfig;
};
//# sourceMappingURL=merge-configs.js.map